import { boolean, defineAction, enumerated, object, string } from '~/prix'
import fetchMonitorUploadUrlAction from './fetchMonitorUploadUrl.action.json'

const fetchMonitorUploadUrlDefinition = defineAction({
  ...fetchMonitorUploadUrlAction,
  input: object({
    file: string().isOptional(),
    contentType: string().isOptional(),
    actionKey: string().isOptional(),
  }),
  output: object({
    success: boolean(),
  }),
})

export default fetchMonitorUploadUrlDefinition
